import React from 'react';

function ChatSection() {
  return (
    <>
      <p>
        Pulina chätissä voi kuunnella random musiikkia, osallistua keskusteluihin vastaamalla toisten viesteihin tai
        kuiskaamalla suoraan toiselle käyttäjälle. Chätin suunnittelussa on painotettu hauskuuteen ja hyödyllisyyteen.
        Voit määrittää itse oman keskustelukuplasi värin ja Pulinabotille kirjoittamasi komennot ja vastaukset näkyvät
        vain sinulle.
      </p>
    </>
  );
}

export default ChatSection;

